export default __webpack_public_path__ + "static/contactInfo-9a5de67fc5857434a05972af2a3eac08.pdf";